import { render } from "./FurnitureRecognitionTab.vue?vue&type=template&id=74a6386c&scoped=true"
import script from "./FurnitureRecognitionTab.vue?vue&type=script&lang=js"
export * from "./FurnitureRecognitionTab.vue?vue&type=script&lang=js"

import "./FurnitureRecognitionTab.vue?vue&type=style&index=0&id=74a6386c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74a6386c"]])

export default __exports__